import { ReactNode } from "react"

import style from "modules/Booking/FormPage/components/UserInfoWithForm/components/Checkbox/style.module.scss"

interface Props {
    checked: boolean
    onChange: () => void
    children: ReactNode
    name: string
    id: string
}

export function Checkbox({ checked, onChange, children, name, id }: Props) {
    return (
        <div className={style.container}>
            <input
                type="checkbox"
                className={style.checkbox}
                id={id}
                name={name}
                checked={checked}
                onChange={onChange}
            />
            <label className={style.label} htmlFor={id}>
                <div className={style.text}>{children}</div>
            </label>
        </div>
    )
}
